import React, { useState } from "react"
import { get, map, includes, filter, chunk } from "lodash"

import { BaseSelect } from "components/atoms/input/select"
import { Sort } from "utils/sort"
import { BaseTable } from "components/molecules/table"
import { SpDetailTable } from "components/molecules/table/spTable"
import { tableColumns } from "config/table_columns"
import { Panel } from "./index"
import { APIResponse } from "redux/apis/types"
import { indexApi } from "components/actions/priceList/worldSummary"
import { indicatorListApi } from "components/actions/indicatorList"
import { SECURITY_TYPE, PAGE_NUM, history } from "config/const"
import { Pagination } from "components/molecules/pagination"
import { checkIsSp } from "utils/util"
import dayjs from "dayjs"

type Props = {
  delete?: Function
  indexData?: Array<object>
  changeIndex?: Function
  indicatorListData?: Array<object>
  changeIndicatorList?: Function
  history?: history
}

const GBFirstNum = SECURITY_TYPE.THGBY10.id
const GBLastNum = SECURITY_TYPE.BRGBY10.id
const quantity = GBLastNum - GBFirstNum + 1
const typeList = Array.from(Array(quantity).keys())
const securityTypeOfGB = map(typeList, num => {
  return GBFirstNum + num
})
const securityTypeOfIndex = [
  SECURITY_TYPE.Index.id,
  SECURITY_TYPE.NK225_Future.id,
  SECURITY_TYPE.CLc1.id,
]
const securityTypeOfFX = [SECURITY_TYPE.SWFX.id]

const getBenchMarkData = (
  indexData: Array<object>,
  typeList: Array<number> | []
) => {
  return filter(indexData, data => {
    return includes(typeList, get(data, "SecurityType"))
  })
}

export const IndexTableList = (props: Props) => {
  const indexData = get(props.indexData, "apiRes", [])
  const indexType = get(props.indexData, "indexType", [])
  const indexTypeNum = get(props.indexData, "indexTypeNum", 0)
  const marketType = get(props.indexData, "marketType", [])
  const displayRangeNum = get(props.indexData, "displayRangeNum")
  const link = get(props.indexData, "link", [])
  const benchMarkList = [
    {
      list: tableColumns.index.summary,
      securityTypes: securityTypeOfIndex,
      link: link[0],
    },
    {
      list: tableColumns.index.currencySummary,
      securityTypes: securityTypeOfFX,
      link: link[1],
    },
    {
      list: tableColumns.index.interest,
      securityTypes: securityTypeOfGB,
      link: link[2],
    },
  ]
  const requestApiParams = !Sort.IndexType[indexTypeNum].displayCountry
    ? Sort.IndexType[indexTypeNum].apiCall
    : get(marketType[displayRangeNum], "apiCall")

  return (
    <Panel
      className="panel-index"
      title="指数"
      delete={props.delete}
      // refresh={() =>
      //   indexApi({
      //     indexTypeNum: indexTypeNum,
      //     marketScopeNum: displayRangeNum,
      //     apiParam: requestApiParams,
      //     changeIndex: props.changeIndex,
      //   })
      // }
      filter={
        <div className="control-row panel-header-filter sp">
          <BaseSelect
            option={Sort.IndexType}
            value={indexTypeNum}
            onChange={(num: number) => {
              indexApi({
                indexTypeNum: num,
                marketScopeNum: 0,
                apiParam: Sort.IndexType[num].apiCall,
                changeIndex: props.changeIndex,
              })
            }}
          />
          {Sort.IndexType[indexTypeNum].displayCountry && (
            <BaseSelect
              option={marketType}
              value={displayRangeNum}
              onChange={(num: number) => {
                indexApi({
                  indexTypeNum: indexTypeNum,
                  marketScopeNum: num,
                  apiParam: marketType[num].apiCall,
                  changeIndex: props.changeIndex,
                })
              }}
            />
          )}
        </div>
      }
    >
      {indexTypeNum === Sort.IndexType[0].id ? (
        <div className="result-list-block">
          {map(benchMarkList, (data, i) => {
            return (
              <BaseTable
                className="table-list-view table-liquid-cell"
                key={i}
                list={data.list}
                data={getBenchMarkData(indexData, data.securityTypes)}
                onClick={(rowData: object) => {
                  if (
                    get(rowData, "SecurityType") ===
                    SECURITY_TYPE.NK225_Future.id
                  ) {
                    props.history.push({
                      pathname: "/domestic/index",
                      state: { rowData },
                    })
                  } else if (
                    get(rowData, "SecurityType") === SECURITY_TYPE.CLc1.id
                  ) {
                    props.history.push({
                      pathname: "/top/instrument",
                      state: { rowData },
                    })
                  } else {
                    props.history.push({
                      pathname: data.link,
                      state: { rowData },
                    })
                  }
                }}
              />
            )
          })}
        </div>
      ) : (
        <BaseTable
          className="table-list-view table-liquid-cell"
          list={indexType}
          data={indexData}
          onClick={(rowData: object) =>
            props.history.push({ pathname: link, state: { rowData } })
          }
        />
      )}
    </Panel>
  )
}

type BankRateType = {
  list: APIResponse.Res
  reload: Function
}
export const BankRateTable: React.FC<BankRateType> = props => {
  const isPhone = checkIsSp()
  return (
    <Panel
      title=""
      className="panel-interest-rate"
      // refresh={props.reload}
      nonePanelHeader={true}
    >
      <BaseTable
        className="table-list-view table-liquid-cell"
        list={tableColumns.bank_rate.top}
        data={get(props.list, "ResultList", [])}
      />
    </Panel>
  )
}

export const EconomicsIndex = (props: Props) => {
  const [currentPage, changePage] = useState<number>(0)
  const indicatorListData = get(props.indicatorListData, "apiRes", {})
  const displayPeriodNum = get(props.indicatorListData, "displayPeriodNum")
  const indicatorTypeNum = get(props.indicatorListData, "indicatorTypeNum")
  const list: Array<Array<object>> = chunk(indicatorListData, PAGE_NUM.PAGE_10)
  const isPhone = checkIsSp()

  return (
    <Panel
      title="経済指標"
      className="panel-economic-indicator panel-fixed-height"
      delete={props.delete}
      // refresh={() =>
      //   indicatorListApi({
      //     displayPeriodNum: displayPeriodNum,
      //     indicatorTypeNum: indicatorTypeNum,
      //     apiParam: Sort.Indicator[indicatorTypeNum].apiCall[displayPeriodNum],
      //     changeIndicatorList: props.changeIndicatorList,
      //   })
      // }
      filter={
        <>
          <div className="control-row panel-header-filter sp">
            <BaseSelect
              option={Sort.EconomicSummaryDate}
              value={displayPeriodNum}
              onChange={(num: number) => {
                indicatorListApi({
                  displayPeriodNum: num,
                  indicatorTypeNum: indicatorTypeNum,
                  apiParam: Sort.Indicator[indicatorTypeNum].apiCall[num],
                  changeIndicatorList: props.changeIndicatorList,
                })
              }}
            />
            <BaseSelect
              option={Sort.Indicator}
              value={indicatorTypeNum}
              onChange={(num: number) => {
                indicatorListApi({
                  displayPeriodNum: displayPeriodNum,
                  indicatorTypeNum: num,
                  apiParam: Sort.Indicator[num].apiCall[displayPeriodNum],
                  changeIndicatorList: props.changeIndicatorList,
                })
              }}
            />
            {/*<span className="panel-header-title-items time">*/}
            {/*  <div className="time-col liquid-item">*/}
            {/*    {dayjs().format("MM/DD HH:mm")}*/}
            {/*  </div>*/}
            {/*</span>*/}
          </div>
        </>
      }
    >
      <div className="result-list-block">
        {!isPhone ? (
          <>
            <BaseTable
              className="table-list-view table-liquid-cell table-economic-indicator"
              list={tableColumns.economics.index}
              data={list[currentPage]}
              onClick={(data: object, i: number) =>
                props.history.push({
                  pathname: "/top/economics",
                  state: { data, activePosition: i, currentPage: currentPage },
                })
              }
            />
            <Pagination
              list={indicatorListData}
              current={currentPage}
              page={PAGE_NUM.PAGE_10}
              changePage={changePage}
            />
          </>
        ) : (
          <SpDetailTable
            headerList={tableColumns.economics.sp.header}
            bodyList={tableColumns.economics.sp.body}
            data={indicatorListData}
          />
        )}
      </div>
    </Panel>
  )
}
